/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type SessionQuarantineReleaseRequestBody = {
  /**
   * The session quarantine ID.
   */
  id: string;
};

/** @internal */
export type SessionQuarantineReleaseRequestBody$Outbound = {
  id: string;
};

/** @internal */
export const SessionQuarantineReleaseRequestBody$outboundSchema: z.ZodMiniType<
  SessionQuarantineReleaseRequestBody$Outbound,
  SessionQuarantineReleaseRequestBody
> = z.object({
  id: z.string(),
});

export function sessionQuarantineReleaseRequestBodyToJSON(
  sessionQuarantineReleaseRequestBody: SessionQuarantineReleaseRequestBody,
): string {
  return JSON.stringify(
    SessionQuarantineReleaseRequestBody$outboundSchema.parse(
      sessionQuarantineReleaseRequestBody,
    ),
  );
}
